import ArrowLeftIcon from 'assets/icons/arrowLeft.svg';
import ArrowRightIcon from 'assets/icons/arrowRight.svg';
import cn from 'classnames/bind';
import Link from 'next/link';
import PropTypes from 'prop-types';
import { DynamicComponent } from 'ui';

import s from './Button.module.scss';

const cx = cn.bind(s);

const Button = ({
  variant,
  as,
  color,
  children,
  hasIcon,
  iconPosition,
  prependIcon,
  className,
  size,
  href,
  skipLink = false,
  ...attrs
}) => {
  const normalizedColor = color === 'danger' ? 'red' : color;
  const combinedClassName = cx(className, 'button', {
    [`variant_${variant}`]: variant,
    [`size_${size}`]: size,
    [`theme_${normalizedColor}`]: normalizedColor,
    'hasIcon': hasIcon,
  });
  const isLink = (as === 'a') && href && !skipLink;
  const buttonProps = {
    tag: as,
    className: combinedClassName,
    ...attrs,
  };
  if (!isLink && href) {
    buttonProps.href = href;
  }
  const button = (
    <DynamicComponent {...buttonProps}>
      {hasIcon && iconPosition === 'start' && (
        <span className={cx('leftArrowIconWrapper')}>
          <ArrowLeftIcon />
        </span>
      )}
      {prependIcon && (
        <span className={cx('prependIcon')}>
          { prependIcon }
        </span>
      )}
      {children}
      {hasIcon && iconPosition === 'end' && (
        <span
          className={cx('arrow', {
            arrowText: variant === 'text',
          })}
        >
          <ArrowRightIcon />
        </span>
      )}
    </DynamicComponent>
  );
  return isLink ? <Link legacyBehavior href={href} passHref>{button}</Link> : button;
};

Button.propTypes = {
  variant: PropTypes.oneOf(['solid', 'text', 'outlined', 'brainable', 'brainableCta', 'brainableAction', 'brainableStatic']),
  hasIcon: PropTypes.bool,
  iconPosition: PropTypes.oneOf(['start', 'end']),
  as: PropTypes.oneOf(['button', 'a']),
  color: PropTypes.oneOf([
    'mint',
    'red',
    'danger',
    'orange',
    'blue',
    'black',
    'white',
    'whiteDark',
    'grey',
    'brown',
  ]),
  size: PropTypes.oneOf(['tiny', 'small', 'medium', 'large']),
  href: PropTypes.string,
};
Button.defaultProps = {
  variant: 'solid',
  hasIcon: false,
  iconPosition: 'end',
  as: 'button',
  color: 'mint',
  size: 'medium',
  href: '',
};

export default Button;
